<template>
    <b-row>
        <b-col cols="12">
            <label>{{ $t('nuevo_abono.tus_asientos') }}</label>
        </b-col>
        <b-col cols="12">
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <b-row class="lightgray-content p-2 mb-2" v-for="(asiento, index) in asientos" :key="index">
                    <b-col cols="12">
                        <div class="d-flex justify-content-between items-center">
                            <div class="oswald text-bold" style="text-transform: capitalize;">
                                {{ tipo === 'abonos' ? $t('general.abono', {abono: teatro.texto_abono}) : $t('partido.entrada') }} {{ ++index }}. 
                                <span v-if="asiento.zona_nombre">{{ asiento.zona_nombre }}</span>
                            </div>
                            <span class="red pointer" :class="{ 'desactivar': loading }" role="button" @click="deleteSeat(asiento.seat_id)">x</span>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div class="ml-2">
                            <small v-if="asiento.fila">{{ $t('general.fila') }}: {{ asiento.fila }} / </small> 
                            <small v-if="asiento.asiento">{{ $t('general.butaca') }}: {{ asiento.asiento }}</small>
                        </div>
                    </b-col>
                    <b-col cols="12" v-if="asiento.precios">
                        <multiselect
                            track-by="id"
                            rules="required"
                            :value="asiento.precio_seleccionado"
                            :disabled="loading"
                            :placeholder="tipo === 'eventos' ? $t('partido.numero_entradas', { entradas: manager.termino_entradas }) : $t('nuevo_abono.numero_abonos', {abonos: teatro.texto_abonos})"
                            :options="asiento.precios"
                            :allow-empty="false"
                            :custom-label="({ name, amount }) => name + ' - ' + $options.filters.formatear_precio(amount)"
                            :preselectFirst="!max_asientos_seleccionados"
                            append-to-body
                            @input="selectPrice(asiento, $event)"
                        />
                    </b-col>
                </b-row>
                <b-row v-if="asientos.length" style="z-index: 1;">
                    <b-col cols="12">
                        <button 
                            :disabled="loading || asientos.some(asiento => !asiento.precio_seleccionado)"
                            class="button effect-button large-button mb-4 mb-lg-5"  
                            @click.prevent="continuar" 
                            type="submit"
                        >
                            <span>
                                {{ $t('nuevo_abono.continuar_compra') }}
                            </span>
                        </button>
                    </b-col>
                </b-row>
            </ValidationObserver>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        props: {
            asientos: {
                type: Array,
                required: true
            },
            loading: {
                type: Boolean,
                default: false
            },
            tipo: {
                type: String,
                default: 'abono'
            },
            zona: {
                type: Object,
                defualt: () => {}
            },
            max_asientos_seleccionados: {
                type: Boolean,
                default: false
            },
            max_seats: {
                type: Number,
                default: 10
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro
            },
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        methods: {
            selectPrice(asiento, nuevoPrecio) {
                const nuevaCatId = nuevoPrecio.salesCategoryId;
                const categoriaNueva = this.zona.configuration[nuevoPrecio.product_id].salesCategories.find(
                    c => c.salesCategoryId === nuevaCatId
                );

                const limite = categoriaNueva?.upperLimit ?? this.max_seats;
                const yaEnNueva = this.asientos.filter(
                    a => a.precio_seleccionado?.salesCategoryId === nuevaCatId
                ).length;

                if (limite == 0 ||yaEnNueva < limite) {
                    this.$set(asiento, 'precio_seleccionado', nuevoPrecio);
                    this.$emit('selectSeat', asiento);
                    this.$emit('setMaxAsientos', false);

                    this.$emit('setUltimoPrecio', nuevoPrecio);
                } else {
                    this.$toast.error('No puedes asignar este precio a más asientos, seleccione otro precio');
                    this.$emit('setMaxAsientos', true);
                }
            },
            deleteSeat(seat_id) {
                this.$emit('deleteSeat', seat_id, false);
            },
            continuar() {
                this.$emit('continuar', this.asientos);
            }
        },
    }
</script>

<style scoped>
    .desactivar {
        pointer-events: none;
        opacity: 0.6;
    }
</style>